
  <form [formGroup]="loginform" (ngSubmit)="send()" class="cont__code_form">
    <div class="form-group">
    <label class="code-label">Código</label>
    <div class="code-inputs">
      <ng-container *ngFor="let control of codeControls; let i = index">
        <input 
          [formControlName]="control"
          type="text"
          maxlength="1"
          class="form-control code-input"
          (input)="onInput($event, i)"
          (keydown)="onKeyDown($event, i)"
          (focus)="onFocus($event)"
          autocomplete="off"
          #codeInput>
      </ng-container>
    </div>
    
    <!-- <div class="code-inputs">
      <ng-container *ngFor="let control of codeControls; let i = index">
        <input [formControlName]="control" type="text" maxlength="1" class="form-control code-input"
          (input)="onInput($event, i)" (keydown)="onKeyDown($event, i)" autocomplete="off" #codeInput>
      </ng-container>
    </div> -->
    <div *ngIf="submitted && loginform.invalid" class="invalid-code">
      <i class="fa-solid fa-circle-exclamation"></i> Asegúrate de ingresar 6 dígitos numéricos.
    </div>
    <div *ngIf="this.logError" class="invalid-code">
      <i class="fa-solid fa-circle-exclamation"></i> El código ingresado es incorrecto.
    </div></div>
    <div class="loginbutton-container"><button type="submit" class="btn-form">Enviar código</button></div>
  </form>

